/* BQA RiverFlow USGS OGC migration v4 - 2026-10-15. Test on development theme before publishing. */
(function () {
  const STYLE_ID = "bqa-riverflow-styles";
// test 
  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement("style");
    style.id = STYLE_ID;

    style.innerHTML = `
    .bqa-riverflow-single {
      --bqa-navy:#123f52;
      --bqa-blue:#00aeef;
      --bqa-text:#172026;
      --bqa-muted:#6b7280;
      --bqa-line:#e5e7eb;
      --bqa-bg:#f4f8fa;
      --bqa-weather-bg:#eef8fc;
      display:grid;
      grid-template-columns:1fr;
      gap:20px;
      max-width:1400px;
      margin:0 auto 24px;
      font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;
    }

    .bqa-riverflow-single.bqa-two-col {
      grid-template-columns:repeat(2,minmax(0,1fr));
    }

    .bqa-flow-card {
      background:#fff;
      border:1px solid var(--bqa-line);
      border-radius:22px;
      overflow:hidden;
      box-shadow:0 8px 24px rgba(20,52,65,.08);
      height:100%;
    }

    .bqa-flow-header {
      background:linear-gradient(135deg,#123f52,#1d6074);
      color:#fff;
      padding:18px;
      display:grid;
      grid-template-columns:1fr auto;
      gap:14px;
      align-items:start;
    }

    .bqa-river-title {
      margin:0;
      font-size:clamp(20px,3vw,30px);
      line-height:1.1;
      font-weight:900;
      color:#fff;
    }

    .bqa-location {
      margin-top:6px;
      font-size:13px;
      opacity:.88;
    }

   .bqa-condition-chip {
  display:none;
}

    .bqa-card-body {
      padding:18px;
      background:var(--bqa-bg);
    }

.bqa-metrics {
  display:grid;
  grid-template-columns:repeat(auto-fit,minmax(160px,1fr));
  gap:10px;
  margin-bottom:14px;
}

    .bqa-metric {
      background:#fff;
      border:1px solid var(--bqa-line);
      border-radius:16px;
      padding:13px;
    }

    .bqa-label {
      color:var(--bqa-muted);
      font-size:11px;
      text-transform:uppercase;
      font-weight:800;
      margin-bottom:7px;
      letter-spacing:.04em;
    }

    .bqa-value {
      font-size:22px;
      font-weight:900;
      color:var(--bqa-text);
    }

    .bqa-flow-value {
      color:var(--bqa-navy);
      font-size:30px;
    }

    .bqa-unit {
      margin-top:4px;
      color:var(--bqa-muted);
      font-size:12px;
    }

    .bqa-chart-panel,
    .bqa-weather-panel {
      background:#fff;
      border:1px solid var(--bqa-line);
      border-radius:18px;
      padding:14px;
      margin-top:14px;
    }

    .bqa-chart-title {
      font-size:15px;
      font-weight:900;
      margin-bottom:10px;
      color:var(--bqa-text);
    }

    .bqa-chart-legend {
      display:flex;
      gap:12px;
      flex-wrap:wrap;
      font-size:12px;
      color:var(--bqa-muted);
      margin-bottom:8px;
    }

    .bqa-legend-item {
      display:inline-flex;
      align-items:center;
      gap:5px;
    }

    .bqa-legend-line {
      display:inline-block;
      width:22px;
      height:0;
      border-top:3px solid #00aeef;
    }

    .bqa-legend-line.hist {
      border-top:2px dashed #9aa0a6;
    }

    .bqa-chart {
      width:100%;
      height:220px;
      overflow:visible;
    }

    .bqa-weather-grid {
      display:grid;
      grid-template-columns:repeat(5,minmax(0,1fr));
      gap:8px;
      margin-top:10px;
    }

    .bqa-weather-day {
      background:var(--bqa-weather-bg);
      border-radius:14px;
      padding:10px 8px;
      text-align:center;
    }

    .bqa-weather-date {
      font-size:12px;
      font-weight:900;
      margin-bottom:6px;
      color:var(--bqa-navy);
    }

    .bqa-weather-icon {
      font-size:24px;
      margin-bottom:6px;
    }

    .bqa-weather-temp {
      font-size:14px;
      font-weight:900;
      color:var(--bqa-text);
    }
.bqa-hist-note {
  border:0 !important;
  background:transparent !important;
  border-radius:0 !important;
  padding:0 !important;
  display:block !important;
}
    .bqa-weather-meta {
      margin-top:4px;
      font-size:11px;
      color:var(--bqa-muted);
      line-height:1.3;
    }

    .bqa-error {
      background:#fff;
      border:1px solid #ffd1d1;
      border-radius:18px;
      padding:18px;
      color:#b91c1c;
    }

    @media (max-width:980px) {
      .bqa-riverflow-single.bqa-two-col {
        grid-template-columns:1fr;
      }
    }

    @media (max-width:640px) {
      .bqa-flow-header,
      .bqa-metrics {
        grid-template-columns:1fr;
      }

      .bqa-weather-grid {
        grid-template-columns:1fr;
      }

      .bqa-chart {
        height:180px;
      }
    }
    `;

    document.head.appendChild(style);
  }

  function fetchJson(url) {
    return fetch(url).then(function (response) {
      if (!response.ok) throw new Error("HTTP " + response.status);
      return response.json();
    });
  }

  function fetchText(url) {
    return fetch(url).then(function (response) {
      if (!response.ok) throw new Error("HTTP " + response.status);
      return response.text();
    });
  }

  function formatNumber(n) {
    if (n === null || n === undefined || isNaN(n)) return "--";
    return Math.round(Number(n)).toLocaleString();
  }

  function formatTime(iso) {
    if (!iso) return "Time unavailable";
    return new Date(iso).toLocaleString([], {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit"
    });
  }

  function formatDateShort(iso) {
    return new Date(iso).toLocaleDateString([], {
      month: "short",
      day: "numeric"
    });
  }

  function yyyyMmDd(date) {
    return date.toISOString().slice(0, 10);
  }

  function daysAgo(days) {
    const d = new Date();
    d.setDate(d.getDate() - days);
    return yyyyMmDd(d);
  }

  function weatherIcon(code) {
    code = Number(code);
    if (code === 0) return "☀️";
    if (code <= 2) return "🌤️";
    if (code === 3) return "☁️";
    if (code >= 51 && code <= 82) return "🌧️";
    if (code >= 71 && code <= 86) return "❄️";
    if (code >= 95) return "⛈️";
    return "🌡️";
  }

async function fetchUSGS(gauge) {
  const site = 'USGS-' + String(gauge.site).replace(/^USGS-/, '');
  const base = 'https://api.waterdata.usgs.gov/ogcapi/v1/collections/';
  function url(collection, parameter, extras) {
    const q = new URLSearchParams(Object.assign({
      f: 'json', monitoring_location_id: site, parameter_code: parameter
    }, extras || {}));
    return base + collection + '/items?' + q.toString();
  }
  const flowData = await fetchJson(url('continuous', '00060', {time:'P5D', limit:'10000'}));
  const cutoff = Date.now() - 5 * 86400000;
  const points = (flowData.features || []).map(function (feature) {
    const p = feature.properties || {};
    return {time:p.time, value:Number(p.value)};
  }).filter(function (p) {
    return p.time && Number.isFinite(p.value) && new Date(p.time).getTime() >= cutoff;
  }).sort(function(a,b){return new Date(a.time)-new Date(b.time);});
  if (!points.length) throw new Error('No recent USGS flow readings found.');
  let latestTemp = null;
  try {
    const tempData = await fetchJson(url('latest-continuous', '00010', {limit:'10'}));
    const temps = (tempData.features || []).map(function(f){return f.properties || {};})
      .filter(function(p){return p.time && Number.isFinite(Number(p.value));})
      .sort(function(a,b){return new Date(b.time)-new Date(a.time);});
    if (temps.length && Date.now() - new Date(temps[0].time).getTime() <= 12*3600000) {
      const unit = String(temps[0].unit_of_measure || '').toLowerCase();
      latestTemp = unit.includes('f') && !unit.includes('c') ? Number(temps[0].value) : Number(temps[0].value)*9/5+32;
    }
  } catch(e) { /* Not all USGS gauges have a water temperature sensor. */ }
  return {sourceName:'USGS', latest:points[points.length-1], points:points, waterTemp:latestTemp};
}

  async function fetchDWR(gauge) {
    const endDate = yyyyMmDd(new Date());
    const startDate = daysAgo(6);

    const dwrUrl =
      `https://dwr.state.co.us/Rest/GET/api/v2/telemetrystations/telemetrytimeserieshour/?format=json&abbrev=${gauge.dwr}&parameter=DISCHRG&startDate=${startDate}&endDate=${endDate}&pageSize=5000`;

    const dwrData = await fetchJson(dwrUrl);

    const rows =
      dwrData.ResultList ||
      dwrData.resultList ||
      dwrData;

    if (!rows || !rows.length) {
      throw new Error("No DWR flow data found.");
    }

    const cutoff = Date.now() - (5 * 24 * 60 * 60 * 1000);

    const points = rows.map(function (r) {
      const time =
        r.measDate ||
        r.measdate ||
        r.dateTime ||
        r.date_time;

      const value =
        r.measValue ||
        r.measvalue ||
        r.amount;

      return {
        time: time,
        value: Number(value)
      };
    }).filter(function (p) {
      return p.time && !isNaN(p.value) && new Date(p.time).getTime() >= cutoff;
    }).sort(function (a, b) {
      return new Date(a.time) - new Date(b.time);
    });

    if (!points.length) throw new Error("No recent DWR readings found.");

    return {
      sourceName: "Colorado DWR",
      latest: points[points.length - 1],
      points: points
    };
  }

  async function fetchFlow(gauge) {
    if (gauge.source === "dwr") return fetchDWR(gauge);
    return fetchUSGS(gauge);
  }

  async function fetchHistorical(gauge, currentPoints) {
    if (!gauge.site || !currentPoints || !currentPoints.length) return [];
    const params = new URLSearchParams({
      monitoring_location_id: 'USGS-' + String(gauge.site).replace(/^USGS-/, ''),
      parameter_code:'00060', computation_type:'arithmetic_mean', normal_type:'DOY', page_size:'10'
    });
    try {
      const data = await fetchJson('https://api.waterdata.usgs.gov/statistics/v0/observationNormals?' + params);
      const values = (data.features || []).flatMap(function(f){
        return (f.properties && f.properties.data || []).filter(function(d){
          return d.parameter_code === '00060';
        }).flatMap(function(d){return d.values || [];});
      });
      const lookup = new Map(values.filter(function(v){return Number.isFinite(Number(v.value));})
        .map(function(v){return [v.time_of_year, Number(v.value)];}));
      const formatter = new Intl.DateTimeFormat('en-US', {timeZone:'America/Denver',month:'2-digit',day:'2-digit'});
      return currentPoints.map(function(p){
        const parts = formatter.formatToParts(new Date(p.time));
        const mm = parts.find(function(v){return v.type === 'month';}).value;
        const dd = parts.find(function(v){return v.type === 'day';}).value;
        const value = lookup.get(mm+'-'+dd);
        return {time:p.time,value:value === undefined ? null : value};
      }).filter(function(p){return p.value !== null;});
    } catch(e) {return [];}
  }

  async function fetchWeather(gauge) {
  if (!gauge.latitude || !gauge.longitude) {
    return { unavailable: true };
  }

  const weatherUrl =
    `https://api.open-meteo.com/v1/forecast?latitude=${gauge.latitude}&longitude=${gauge.longitude}&daily=weather_code,temperature_2m_max,temperature_2m_min&temperature_unit=fahrenheit&timezone=auto&forecast_days=5`;

  try {
    return await fetchJson(weatherUrl);
  } catch (e) {
    return { unavailable: true };
  }
}

  function buildChart(points, historicalPoints) {
    if (!points || points.length < 2) {
      return `<div class="bqa-error">Not enough data to draw chart.</div>`;
    }

    const allValues = points
      .concat(historicalPoints || [])
      .map(function (p) {
        return p.value;
      })
      .filter(function (v) {
        return !isNaN(v);
      });

    const min = Math.min.apply(null, allValues);
    const max = Math.max.apply(null, allValues);
    const range = max - min || 1;

    function xPos(i, total) {
      return (i / Math.max(total - 1, 1)) * 630 + 50;
    }

    function yPos(value) {
      return 190 - ((value - min) / range) * 170;
    }

    const liveLine = points.map(function (p, i) {
      return xPos(i, points.length) + "," + yPos(p.value);
    }).join(" ");

    let historicalLine = "";

    if (historicalPoints && historicalPoints.length > 1) {
      historicalLine = historicalPoints.map(function (p, i) {
        return xPos(i, historicalPoints.length) + "," + yPos(p.value);
      }).join(" ");
    }

    return `
      <div class="bqa-chart-legend">
        <span class="bqa-legend-item">
          <span class="bqa-legend-line"></span> Recent readings
        </span>
        <span class="bqa-legend-item">
          <span class="bqa-legend-line hist"></span> Historical average
        </span>
      </div>

      <svg class="bqa-chart" viewBox="0 0 700 220">

        <text x="10" y="12" font-size="11" fill="#6b7280" font-weight="700">CFS</text>

        <text x="10" y="25" font-size="11" fill="#6b7280">${Math.round(max)}</text>
        <text x="10" y="110" font-size="11" fill="#6b7280">${Math.round((max + min) / 2)}</text>
        <text x="10" y="195" font-size="11" fill="#6b7280">${Math.round(min)}</text>

        <line x1="50" y1="20" x2="690" y2="20" stroke="#e5e7eb" stroke-width="1" />
        <line x1="50" y1="105" x2="690" y2="105" stroke="#e5e7eb" stroke-width="1" />
        <line x1="50" y1="190" x2="690" y2="190" stroke="#e5e7eb" stroke-width="1" />

        ${
          historicalLine
            ? `<polyline points="${historicalLine}" fill="none" stroke="#9aa0a6" stroke-width="2" stroke-dasharray="7 6" />`
            : ""
        }

        <polyline
          points="${liveLine}"
          fill="none"
          stroke="#00aeef"
          stroke-width="2"
        />

        ${points.map(function (p, i) {
          return `
            <circle
              cx="${xPos(i, points.length)}"
              cy="${yPos(p.value)}"
              r="2.75"
              fill="#00aeef"
            />
          `;
        }).join("")}

        <text x="50" y="215" font-size="11" fill="#6b7280">
          ${formatDateShort(points[0].time)}
        </text>

        <text x="350" y="215" text-anchor="middle" font-size="11" fill="#6b7280">
          ${formatDateShort(points[Math.floor(points.length / 2)].time)}
        </text>

        <text x="690" y="215" text-anchor="end" font-size="11" fill="#6b7280">
          ${formatDateShort(points[points.length - 1].time)}
        </text>

      </svg>
    `;
  }

  function buildWeather(weather) {
    if (!weather || weather.unavailable || !weather.daily || !weather.daily.time) {
      return `
        <section class="bqa-weather-panel">
          <div class="bqa-chart-title">5-Day Weather Outlook</div>
          <div class="bqa-unit">Weather forecast temporarily unavailable.</div>
        </section>
      `;
    }

    return `
      <section class="bqa-weather-panel">
        <div class="bqa-chart-title">5-Day Weather Outlook</div>

        <div class="bqa-weather-grid">
          ${weather.daily.time.map(function (d, i) {
            return `
              <div class="bqa-weather-day">
                <div class="bqa-weather-date">
                  ${new Date(d + "T12:00:00").toLocaleDateString([], {
                    weekday: "short",
                    month: "short",
                    day: "numeric"
                  })}
                </div>

                <div class="bqa-weather-icon">
                  ${weatherIcon(weather.daily.weather_code[i])}
                </div>

                <div class="bqa-weather-temp">
                  ${Math.round(weather.daily.temperature_2m_max[i])}°
                  /
                  ${Math.round(weather.daily.temperature_2m_min[i])}°
                </div>

                <div class="bqa-weather-meta">
                 Forecast outlook
                </div>
              </div>
            `;
          }).join("")}
        </div>
      </section>
    `;
  }

  async function loadRiver(gauge, root) {
    try {
      const flow = await fetchFlow(gauge);

      let historical = [];
      try {
        historical = await fetchHistorical(gauge, flow.points);
      } catch (e) {
        historical = [];
      }

      const weather = await fetchWeather(gauge);

      root.innerHTML = `
        <article class="bqa-flow-card">
          <header class="bqa-flow-header">
            <div>
              <h2 class="bqa-river-title">
                ${gauge.riverName} — ${gauge.locationName}
              </h2>

              <div class="bqa-location">
                ${flow.sourceName} • Updated ${formatTime(flow.latest.time)}
              </div>
           </div>

            <div class="bqa-condition-chip">
              Live Conditions
            </div>
          </header>

          <div class="bqa-card-body">
  <div class="bqa-metrics">
  <div class="bqa-metric">
    <div class="bqa-label">Current Flow</div>
    <div class="bqa-value bqa-flow-value">
      ${formatNumber(flow.latest.value)}
    </div>
    <div class="bqa-unit">CFS</div>
  </div>

  <div class="bqa-metric">
    <div class="bqa-label">Historical Ref.</div>
    <div class="bqa-value">
      ${
        historical && historical.length
          ? formatNumber(historical[historical.length - 1].value)
          : "Not Available"
      }
    </div>
    <div class="bqa-unit bqa-hist-note">Historical average</div>
  </div>

  <div class="bqa-metric">
    <div class="bqa-label">Water Temp</div>
    <div class="bqa-value">
      ${
        flow.waterTemp
          ? Math.round(flow.waterTemp) + "°"
          : "--"
      }
    </div>
    <div class="bqa-unit">Fahrenheit</div>
  </div>
</div>




            <section class="bqa-chart-panel">
              <div class="bqa-chart-title">
                5-Day Flow Trend vs Historical Average
              </div>
              ${buildChart(flow.points, historical)}
            </section>

            ${buildWeather(weather)}
          </div>
        </article>
      `;
    } catch (error) {
      root.innerHTML = `
        <div class="bqa-error">
          <strong>${gauge.riverName} — ${gauge.locationName}</strong><br>
          Unable to load river data. ${error.message || ""}
        </div>
      `;
    }
  }

  function initBQARiverFlow() {
    const container = document.querySelector("[data-bqa-riverflow]");

    if (
      !container ||
      !window.BQA_RIVERS ||
      container.dataset.loaded === "true"
    ) {
      return;
    }

    container.dataset.loaded = "true";

    if (window.BQA_RIVERS.length > 1) {
      container.classList.add("bqa-two-col");
    }

    window.BQA_RIVERS.forEach(function (gauge) {
      const card = document.createElement("div");

      card.innerHTML = `
        <div class="bqa-flow-card">
          <div class="bqa-card-body">
            Loading ${gauge.riverName} — ${gauge.locationName}...
          </div>
        </div>
      `;

      container.appendChild(card);
      loadRiver(gauge, card);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBQARiverFlow);
  } else {
    initBQARiverFlow();
  }

setTimeout(initBQARiverFlow, 500);
setTimeout(initBQARiverFlow, 1500);
setTimeout(initBQARiverFlow, 3000);

})();

(function () {
  "use strict";

  var APP_ID = "bqa-tv-streamflow";
  var app = document.getElementById(APP_ID);
  if (!app || app.getAttribute("data-initialized") === "true") return;
  app.setAttribute("data-initialized", "true");
  document.body.classList.add("bqa-tv-streamflow-mode");

  var CONFIG = {
    flowRefreshMs: 15 * 60 * 1000,
    weatherRefreshMs: 60 * 60 * 1000,
    hardReloadMs: 6 * 60 * 60 * 1000,
    flowCacheMaxAgeMs: 6 * 60 * 60 * 1000,
    weatherCacheMaxAgeMs: 6 * 60 * 60 * 1000,
    pointCacheMaxAgeMs: 30 * 24 * 60 * 60 * 1000,
    staleReadingMs: 12 * 60 * 60 * 1000,
    dwrHistoricalYears: 10,
    maxWeatherConcurrency: 4,
    demoMode: /(?:\?|&)demo=1(?:&|$)/.test(window.location.search)
  };

  /*
    This is the only section normally edited when adding, removing, or reordering rivers.
    "historical": USGS period-of-record average is used when available; DWR 10-year average is the fallback.
  */
  var RIVERS = [
    {
      id: "arkansas-salida",
      river: "Arkansas River",
      location: "At Salida",
      usgs: "07093700",
      dwr: "ARKSALCO",
      preferDwr: true,
      lat: 38.5347,
      lon: -105.9989
    },
    {
      id: "bear-morrison",
      river: "Bear Creek",
      location: "At Morrison",
      usgs: "06710500",
      dwr: "BCRMORCO",
      preferDwr: true,
      lat: 39.6536,
      lon: -105.1911
    },
    {
      id: "blue-dillon",
      river: "Blue River",
      location: "Below Dillon Reservoir",
      usgs: "09050700",
      lat: 39.6256,
      lon: -106.0658
    },
    {
      id: "clear-golden",
      river: "Clear Creek",
      location: "At Golden",
      usgs: "06719505",
      lat: 39.7555,
      lon: -105.2211
    },
    {
      id: "colorado-kremmling",
      river: "Colorado River",
      location: "Near Kremmling",
      usgs: "09058000",
      lat: 40.0597,
      lon: -106.3889
    },
    {
      id: "eagle-gypsum",
      river: "Eagle River",
      location: "Below Gypsum",
      usgs: "09070000",
      lat: 39.6469,
      lon: -106.9517
    },
    {
      id: "fryingpan-ruedi",
      river: "Fryingpan River",
      location: "Near Ruedi Reservoir",
      usgs: "09080400",
      lat: 39.3622,
      lon: -106.8167
    },
    {
      id: "roaringfork-glenwood",
      river: "Roaring Fork River",
      location: "At Glenwood Springs",
      usgs: "09085000",
      lat: 39.5505,
      lon: -107.3248
    },
    {
      id: "platte-dream",
      river: "South Platte River",
      location: "Dream Stream",
      dwr: "PLAHARCO",
      preferDwr: true,
      lat: 38.9678,
      lon: -105.5815
    },
    {
      id: "platte-elevenmile",
      river: "South Platte River",
      location: "11 Mile Canyon",
      dwr: "PLAGEOCO",
      preferDwr: true,
      lat: 38.9053,
      lon: -105.4733
    },
    {
      id: "platte-cheesman",
      river: "South Platte River",
      location: "Cheesman Canyon",
      usgs: "06701500",
      dwr: "PLACHECO",
      preferDwr: true,
      lat: 39.2150,
      lon: -105.2780
    },
    {
      id: "platte-deckers",
      river: "South Platte River",
      location: "At Deckers",
      usgs: "06701900",
      lat: 39.2547,
      lon: -105.2272
    },
    {
      id: "northfork-bailey",
      river: "North Fork South Platte",
      location: "At Bailey",
      dwr: "PLABAICO",
      preferDwr: true,
      lat: 39.4050,
      lon: -105.4750
    },
    {
      id: "williamsfork-reservoir",
      river: "Williams Fork River",
      location: "Below Williams Fork Reservoir",
      usgs: "09038500",
      lat: 40.0359,
      lon: -106.2050
    }
  ];

  var state = {
    flowById: {},
    weatherById: {},
    isFlowLoading: false,
    isWeatherLoading: false,
    lastFlowSuccess: null,
    lastWeatherSuccess: null,
    errorCount: 0
  };

  var leftEl = document.getElementById("bqa-tv-left");
  var rightEl = document.getElementById("bqa-tv-right");
  var statusEl = document.getElementById("bqa-tv-status");
  var liveDotEl = document.getElementById("bqa-tv-live-dot");
  var updatedEl = document.getElementById("bqa-tv-updated");

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function pad2(value) {
    return String(value).padStart(2, "0");
  }

  function localDateString(date) {
    return date.getFullYear() + "-" + pad2(date.getMonth() + 1) + "-" + pad2(date.getDate());
  }

  function dateForApi(date) {
    return localDateString(date);
  }

  function startDateForDwr() {
    var d = new Date();
    d.setDate(d.getDate() - 2);
    return dateForApi(d);
  }

  function endDateForDwr() {
    return dateForApi(new Date());
  }

  function formatClock() {
    var now = new Date();
    var time = now.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit"
    });
    var date = now.toLocaleDateString([], {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric"
    });
    document.getElementById("bqa-tv-clock").textContent = time;
    document.getElementById("bqa-tv-date").textContent = date;
  }

  function safeNumber(value) {
    var n = Number(value);
    if (!Number.isFinite(n) || n <= -999000) return null;
    return n;
  }

  function formatFlow(value) {
    if (value == null || !Number.isFinite(value)) return "--";
    if (value < 10) return value.toFixed(1);
    return Math.round(value).toLocaleString();
  }

  function formatTemp(value) {
    if (value == null || !Number.isFinite(value)) return "--";
    return Math.round(value) + "&deg;";
  }

  function tempClass(value) {
    if (value == null || !Number.isFinite(value)) return "";
    if (value >= 68) return "is-danger";
    if (value >= 66) return "is-caution";
    return "is-good";
  }

  function tempNote(value) {
    if (value == null || !Number.isFinite(value)) return "NO SENSOR";
    if (value >= 68) return "STOP FISHING";
    if (value >= 66) return "USE CAUTION";
    return "DEG F";
  }

  function minutesAgoText(dateValue) {
    if (!dateValue) return "TIME N/A";
    var d = new Date(dateValue);
    if (Number.isNaN(d.getTime())) return "TIME N/A";
    var diffMin = Math.max(0, Math.round((Date.now() - d.getTime()) / 60000));
    if (diffMin < 2) return "JUST UPDATED";
    if (diffMin < 60) return diffMin + " MIN AGO";
    var diffHr = Math.round(diffMin / 60);
    if (diffHr < 24) return diffHr + " HR AGO";
    return d.toLocaleDateString([], { month: "short", day: "numeric" }).toUpperCase();
  }

  function cacheRead(key, maxAgeMs) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;
      var item = JSON.parse(raw);
      if (!item || !item.savedAt || typeof item.data === "undefined") return null;
      if (maxAgeMs && Date.now() - item.savedAt > maxAgeMs) return null;
      return item.data;
    } catch (error) {
      return null;
    }
  }

  function cacheWrite(key, data) {
    try {
      localStorage.setItem(key, JSON.stringify({ savedAt: Date.now(), data: data }));
    } catch (error) {
      /* Storage can be unavailable in privacy mode; live operation continues. */
    }
  }

  function fetchJson(url, options) {
    var requestOptions = options || {};
    return fetch(url, requestOptions).then(function (response) {
      if (!response.ok) throw new Error("HTTP " + response.status + " for " + url);
      return response.json();
    });
  }

  function fetchText(url) {
    return fetch(url).then(function (response) {
      if (!response.ok) throw new Error("HTTP " + response.status + " for " + url);
      return response.text();
    });
  }

  function getUsgsSeriesCode(series) {
    try {
      return String(series.variable.variableCode[0].value || "");
    } catch (error) {
      return "";
    }
  }

  function getUsgsSeriesSite(series) {
    try {
      return String(series.sourceInfo.siteCode[0].value || "");
    } catch (error) {
      return "";
    }
  }

  function newestUsgsValue(data, site, parameterCode) {
    const records = data && data.features || [];
    let best = null;
    records.forEach(function(feature){
      const p = feature.properties || {};
      if (p.monitoring_location_id !== 'USGS-' + site || p.parameter_code !== parameterCode) return;
      const value = safeNumber(p.value);
      const timeMs = new Date(p.time || 0).getTime();
      if (value == null || !Number.isFinite(timeMs)) return;
      if (!best || timeMs > best.timeMs) {
        best = {value:value,time:p.time,timeMs:timeMs,siteName:p.monitoring_location_name || ''};
      }
    });
    return best;
  }

  function cToF(value) {
    return (Number(value) * 9 / 5) + 32;
  }

  function normalizeTemperature(value, units) {
    var n = safeNumber(value);
    if (n == null) return null;
    var unitText = String(units || "").toUpperCase();
    if (unitText.indexOf("C") !== -1 && unitText.indexOf("F") === -1) return cToF(n);
    if (!unitText && n < 45) return cToF(n);
    return n;
  }

  function parseUsgsHistoricalFeature(data, site) {
    const feature = (data.features || []).find(function(f){
      return f.properties && f.properties.monitoring_location_id === 'USGS-' + site;
    });
    if (!feature) return null;
    const sets = (feature.properties.data || []).filter(function(d){return d.parameter_code === '00060';});
    const today = new Intl.DateTimeFormat('en-US',{timeZone:'America/Denver',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const key = today.find(function(x){return x.type === 'month';}).value + '-' + today.find(function(x){return x.type === 'day';}).value;
    for (const set of sets) {
      const record = (set.values || []).find(function(v){return v.time_of_year === key;});
      if (record && Number.isFinite(Number(record.value))) {
        return {value:Number(record.value),years:safeNumber(record.sample_count),label:'P.O.R. AVG'};
      }
    }
    return null;
  }

  function extractDwrRows(payload) {
    if (Array.isArray(payload)) return payload;
    if (!payload || typeof payload !== "object") return [];
    return payload.ResultList || payload.resultList || payload.results || payload.Result || [];
  }

  function dwrCode(row) {
    return String(
      row.abbrev || row.Abbrev || row.stationAbbrev || row.stationabbrev ||
      row.stationAbbreviation || row.stationabbreviation || ""
    ).toUpperCase();
  }

  function dwrValue(row) {
    return safeNumber(
      row.measValue != null ? row.measValue :
      row.measvalue != null ? row.measvalue :
      row.value != null ? row.value :
      row.Value != null ? row.Value :
      row.amount
    );
  }

  function dwrDate(row) {
    return row.measDate || row.measdate || row.dateTime || row.datetime || row.date || row.Date || null;
  }

  function dwrUnits(row) {
    return row.measUnit || row.measunit || row.units || row.unit || row.Unit || "";
  }

  function dwrParameter(row) {
    return String(row.parameter || row.Parameter || row.measType || row.meastype || "").toUpperCase();
  }

  function newestDwrByCode(payload, isTemperature) {
    var rows = extractDwrRows(payload);
    var result = {};
    rows.forEach(function (row) {
      var code = dwrCode(row);
      var value = dwrValue(row);
      var date = dwrDate(row);
      var timeMs = new Date(date || 0).getTime();
      if (!code || value == null || !timeMs) return;
      var normalized = isTemperature ? normalizeTemperature(value, dwrUnits(row)) : value;
      if (normalized == null) return;
      if (!result[code] || timeMs > result[code].timeMs) {
        result[code] = {
          value: normalized,
          time: date,
          timeMs: timeMs,
          units: dwrUnits(row)
        };
      }
    });
    return result;
  }

  function buildDwrUrl(endpoint, codes, parameter, startDate, endDate, pageSize) {
    var params = new URLSearchParams({
      format: "json",
      abbrev: codes.join(","),
      parameter: parameter,
      startDate: startDate,
      endDate: endDate,
      pageSize: String(pageSize || 5000)
    });
    return "https://dwr.state.co.us/Rest/GET/api/v2/telemetrystations/" + endpoint + "/?" + params.toString();
  }

  function fetchDwrCurrent(codes, parameter) {
    if (!codes.length) return Promise.resolve({});
    var url = buildDwrUrl(
      "telemetrytimeserieshour",
      codes,
      parameter,
      startDateForDwr(),
      endDateForDwr(),
      10000
    );
    return fetchJson(url).then(function (payload) {
      return newestDwrByCode(payload, parameter === "WATTEMP");
    });
  }

  function parseDwrCurrentBundle(payload) {
    var rows = extractDwrRows(payload);
    var flowRows = [];
    var tempRows = [];
    rows.forEach(function (row) {
      var parameter = dwrParameter(row);
      if (parameter === "DISCHRG") flowRows.push(row);
      if (parameter === "WATTEMP" || parameter.indexOf("TEMP") !== -1) tempRows.push(row);
    });
    return {
      flow: newestDwrByCode(flowRows, false),
      temp: newestDwrByCode(tempRows, true)
    };
  }

  function fetchDwrCurrentBundle(codes) {
    if (!codes.length) return Promise.resolve({ flow: {}, temp: {} });
    var url = buildDwrUrl(
      "telemetrytimeserieshour",
      codes,
      "DISCHRG,WATTEMP",
      startDateForDwr(),
      endDateForDwr(),
      10000
    );

    return fetchJson(url)
      .then(parseDwrCurrentBundle)
      .catch(function () {
        /* Fallback for any station/API edge case involving multi-parameter requests. */
        return Promise.all([
          fetchDwrCurrent(codes, "DISCHRG").catch(function () { return {}; }),
          fetchDwrCurrent(codes, "WATTEMP").catch(function () { return {}; })
        ]).then(function (parts) {
          return { flow: parts[0], temp: parts[1] };
        });
      });
  }

  function sameMonthDayInYear(year) {
    var now = new Date();
    var month = now.getMonth();
    var day = now.getDate();
    var d = new Date(year, month, day);
    if (d.getMonth() !== month) d = new Date(year, month, day - 1);
    return localDateString(d);
  }

  function fetchDwrHistorical(codes) {
    if (!codes.length) return Promise.resolve({});
    var cacheKey = "bqaTvDwrHistorical:v3:" + localDateString(new Date()) + ":" + codes.join("-");
    var cached = cacheRead(cacheKey, 30 * 60 * 60 * 1000);
    if (cached) return Promise.resolve(cached);

    var currentYear = new Date().getFullYear();
    var requests = [];
    for (var offset = 1; offset <= CONFIG.dwrHistoricalYears; offset += 1) {
      var date = sameMonthDayInYear(currentYear - offset);
      var url = buildDwrUrl("telemetrytimeseriesday", codes, "DISCHRG", date, date, 1000);
      requests.push(fetchJson(url).catch(function () { return null; }));
    }

    return Promise.all(requests).then(function (payloads) {
      var buckets = {};
      payloads.forEach(function (payload) {
        if (!payload) return;
        extractDwrRows(payload).forEach(function (row) {
          var code = dwrCode(row);
          var value = dwrValue(row);
          if (!code || value == null) return;
          if (!buckets[code]) buckets[code] = [];
          buckets[code].push(value);
        });
      });

      var result = {};
      Object.keys(buckets).forEach(function (code) {
        var values = buckets[code];
        if (!values.length) return;
        result[code] = {
          value: values.reduce(function (sum, value) { return sum + value; }, 0) / values.length,
          years: values.length,
          label: values.length + " YR AVG"
        };
      });
      cacheWrite(cacheKey, result);
      return result;
    });
  }

  function fetchUsgsCurrent(sites) {
    if (!sites.length) return Promise.resolve({features:[]});
    const base = 'https://api.waterdata.usgs.gov/ogcapi/v1/collections/latest-continuous/items?';
    const requests = sites.flatMap(function(site){return ['00060','00010'].map(function(parameter){
      const q = new URLSearchParams({f:'json',monitoring_location_id:'USGS-'+site,parameter_code:parameter,limit:'10'});
      return fetchJson(base+q).catch(function(){return {features:[]};});
    });});
    return Promise.all(requests).then(function(parts){
      return {features:parts.flatMap(function(part){return part.features || [];})};
    });
  }

  function fetchUsgsHistorical(sites) {
    if (!sites.length) return Promise.resolve({});
    const cacheKey = 'bqaTvUsgsHistorical:v4:' + localDateString(new Date()) + ':' + sites.join('-');
    const cached = cacheRead(cacheKey,30*60*60*1000);
    if (cached) return Promise.resolve(cached);
    const requests = sites.map(function(site){
      const q = new URLSearchParams({monitoring_location_id:'USGS-'+site,parameter_code:'00060',computation_type:'arithmetic_mean',normal_type:'DOY',page_size:'10'});
      return fetchJson('https://api.waterdata.usgs.gov/statistics/v0/observationNormals?'+q)
        .then(function(data){return {site:site,result:parseUsgsHistoricalFeature(data,site)};})
        .catch(function(){return {site:site,result:null};});
    });
    return Promise.all(requests).then(function(parts){
      const result = {};
      parts.forEach(function(part){if(part.result) result[part.site] = part.result;});
      cacheWrite(cacheKey,result);
      return result;
    });
  }

  function uniqueValues(values) {
    return values.filter(function (value, index, arr) {
      return value && arr.indexOf(value) === index;
    });
  }

  function mergeLiveFlowData(usgsPayload, usgsHistorical, dwrFlow, dwrTemp, dwrHistorical) {
    var results = {};

    RIVERS.forEach(function (river) {
      var usgsFlow = river.usgs ? newestUsgsValue(usgsPayload, river.usgs, "00060") : null;
      var usgsTemp = river.usgs ? newestUsgsValue(usgsPayload, river.usgs, "00010") : null;
      var dwrFlowValue = river.dwr ? dwrFlow[String(river.dwr).toUpperCase()] : null;
      var dwrTempValue = river.dwr ? dwrTemp[String(river.dwr).toUpperCase()] : null;

      var current = null;
      if (river.preferDwr && dwrFlowValue) {
        current = { value: dwrFlowValue.value, time: dwrFlowValue.time, source: "CO DWR" };
      } else if (usgsFlow) {
        current = { value: usgsFlow.value, time: usgsFlow.time, source: "USGS" };
      } else if (dwrFlowValue) {
        current = { value: dwrFlowValue.value, time: dwrFlowValue.time, source: "CO DWR" };
      }

      var temperature = null;
      var tempTime = null;
      var tempSource = null;
      if (usgsTemp) {
        temperature = cToF(usgsTemp.value);
        tempTime = usgsTemp.time;
        tempSource = "USGS";
      } else if (dwrTempValue) {
        temperature = dwrTempValue.value;
        tempTime = dwrTempValue.time;
        tempSource = "CO DWR";
      }

      var historical = river.usgs && usgsHistorical[river.usgs]
        ? usgsHistorical[river.usgs]
        : null;
      if (!historical && river.dwr && dwrHistorical[String(river.dwr).toUpperCase()]) {
        historical = dwrHistorical[String(river.dwr).toUpperCase()];
      }

      if (!current) {
        var cached = cacheRead("bqaTvFlow:v3:" + river.id, CONFIG.flowCacheMaxAgeMs);
        if (cached) {
          cached.cached = true;
          results[river.id] = cached;
          return;
        }
      }

      var item = {
        current: current ? current.value : null,
        currentTime: current ? current.time : null,
        source: current ? current.source : "UNAVAILABLE",
        historical: historical ? historical.value : null,
        historicalLabel: historical ? historical.label : "NO HISTORY",
        historicalYears: historical ? historical.years : null,
        tempF: temperature,
        tempTime: tempTime,
        tempSource: tempSource,
        cached: false
      };

      if (current) cacheWrite("bqaTvFlow:v3:" + river.id, item);
      results[river.id] = item;
    });

    return results;
  }

  function createDemoFlow() {
    var current = [1120, 31, 188, 72, 1430, 238, 201, 418, 146, 169, 317, 325, 42, 247];
    var historical = [890, 44, 156, 91, 1250, 290, 184, 560, 211, 206, 274, 289, 54, 139];
    var temperatures = [63, 64, 51, 66.4, 67.2, 68.4, 44, 69.1, 57, 54, 55, 61, null, 50];
    var result = {};
    RIVERS.forEach(function (river, index) {
      result[river.id] = {
        current: current[index],
        currentTime: new Date(Date.now() - (index % 4) * 14 * 60000).toISOString(),
        source: river.dwr && river.preferDwr ? "CO DWR" : "USGS",
        historical: historical[index],
        historicalLabel: river.dwr && !river.usgs ? "10 YR AVG" : "P.O.R. AVG",
        historicalYears: river.dwr && !river.usgs ? 10 : 38,
        tempF: temperatures[index],
        tempTime: new Date().toISOString(),
        tempSource: temperatures[index] == null ? null : (river.dwr && !river.usgs ? "CO DWR" : "USGS"),
        cached: false
      };
    });
    return result;
  }

  function loadFlowData() {
    if (state.isFlowLoading) return Promise.resolve();
    state.isFlowLoading = true;
    setStatus("UPDATING RIVER DATA", "loading");

    if (CONFIG.demoMode) {
      state.flowById = createDemoFlow();
      state.lastFlowSuccess = new Date();
      state.isFlowLoading = false;
      renderAll();
      setStatus("DEMO DISPLAY", "ok");
      return Promise.resolve();
    }

    var usgsSites = uniqueValues(RIVERS.map(function (river) { return river.usgs; }));
    var dwrCodes = uniqueValues(RIVERS.map(function (river) { return river.dwr; }));

    return Promise.all([
      fetchUsgsCurrent(usgsSites).catch(function () { return null; }),
      fetchUsgsHistorical(usgsSites).catch(function () { return {}; }),
      fetchDwrCurrentBundle(dwrCodes).catch(function () { return { flow: {}, temp: {} }; }),
      fetchDwrHistorical(dwrCodes).catch(function () { return {}; })
    ]).then(function (parts) {
      state.flowById = mergeLiveFlowData(parts[0], parts[1], parts[2].flow, parts[2].temp, parts[3]);
      state.lastFlowSuccess = new Date();
      state.errorCount = RIVERS.filter(function (river) {
        var item = state.flowById[river.id];
        return !item || item.current == null;
      }).length;
      renderAll();
      setStatus(state.errorCount ? "LIVE WITH " + state.errorCount + " DATA GAP" + (state.errorCount === 1 ? "" : "S") : "LIVE DATA", state.errorCount ? "warning" : "ok");
    }).catch(function () {
      state.errorCount = RIVERS.length;
      renderAll();
      setStatus("DATA CONNECTION ISSUE", "warning");
    }).finally(function () {
      state.isFlowLoading = false;
      updateFooter();
    });
  }

  function weatherSymbol(shortForecast) {
    var text = String(shortForecast || "").toLowerCase();
    if (/thunder|storm/.test(text)) return "&#9889;";
    if (/snow|sleet|ice|blizzard/.test(text)) return "&#10052;";
    if (/rain|shower|drizzle/.test(text)) return "&#9730;";
    if (/fog|haze|smoke/.test(text)) return "&#8801;";
    if (/cloud|overcast/.test(text)) return "&#9729;";
    if (/partly|mostly sunny|mostly clear/.test(text)) return "&#9925;";
    return "&#9728;";
  }

  function extractThreeDayForecast(payload) {
    var periods = payload && payload.properties && Array.isArray(payload.properties.periods)
      ? payload.properties.periods
      : [];
    var days = [];

    for (var i = 0; i < periods.length && days.length < 3; i += 1) {
      var daytime = periods[i];
      if (!daytime.isDaytime) continue;
      var nighttime = null;
      for (var j = i + 1; j < periods.length; j += 1) {
        if (periods[j].isDaytime) break;
        nighttime = periods[j];
        break;
      }
      days.push({
        date: daytime.startTime,
        high: safeNumber(daytime.temperature),
        low: nighttime ? safeNumber(nighttime.temperature) : null,
        icon: daytime.icon || "",
        shortForecast: daytime.shortForecast || "Forecast"
      });
    }
    return days;
  }

  function nwsHeaders() {
    return { Accept: "application/geo+json" };
  }

  function fetchNwsForecastForRiver(river) {
    var weatherCacheKey = "bqaTvWeather:v3:" + river.id;
    var pointKey = river.lat.toFixed(4) + "," + river.lon.toFixed(4);
    var pointCacheKey = "bqaTvNwsPoint:v2:" + pointKey;
    var pointCache = cacheRead(pointCacheKey, CONFIG.pointCacheMaxAgeMs);

    function getForecastUrl() {
      if (pointCache && pointCache.forecastUrl) return Promise.resolve(pointCache.forecastUrl);
      return fetchJson("https://api.weather.gov/points/" + pointKey, { headers: nwsHeaders() })
        .then(function (payload) {
          var forecastUrl = payload && payload.properties ? payload.properties.forecast : null;
          if (!forecastUrl) throw new Error("NWS forecast URL unavailable");
          cacheWrite(pointCacheKey, { forecastUrl: forecastUrl });
          return forecastUrl;
        });
    }

    return getForecastUrl()
      .then(function (forecastUrl) {
        return fetchJson(forecastUrl, { headers: nwsHeaders() });
      })
      .then(function (payload) {
        var days = extractThreeDayForecast(payload);
        if (!days.length) throw new Error("NWS periods unavailable");
        var result = { days: days, cached: false, updatedAt: new Date().toISOString() };
        cacheWrite(weatherCacheKey, result);
        return result;
      })
      .catch(function (error) {
        var cached = cacheRead(weatherCacheKey, CONFIG.weatherCacheMaxAgeMs);
        if (cached) {
          cached.cached = true;
          return cached;
        }
        return { days: [], cached: false, error: true, updatedAt: null };
      });
  }

  function mapLimit(items, limit, worker) {
    var results = new Array(items.length);
    var nextIndex = 0;

    function runOne() {
      var index = nextIndex;
      nextIndex += 1;
      if (index >= items.length) return Promise.resolve();
      return Promise.resolve(worker(items[index], index))
        .then(function (result) { results[index] = result; })
        .then(runOne);
    }

    var workers = [];
    var workerCount = Math.min(limit, items.length);
    for (var i = 0; i < workerCount; i += 1) workers.push(runOne());
    return Promise.all(workers).then(function () { return results; });
  }

  function createDemoWeather() {
    var forecasts = [
      ["Sunny", 78, 47],
      ["Partly Sunny", 75, 45],
      ["Scattered Thunderstorms", 71, 44]
    ];
    var result = {};
    RIVERS.forEach(function (river, riverIndex) {
      result[river.id] = {
        cached: false,
        updatedAt: new Date().toISOString(),
        days: forecasts.map(function (item, dayIndex) {
          var d = new Date();
          d.setDate(d.getDate() + dayIndex);
          return {
            date: d.toISOString(),
            high: item[1] - (riverIndex % 5),
            low: item[2] - (riverIndex % 4),
            icon: "",
            shortForecast: item[0]
          };
        })
      };
    });
    return result;
  }

  function loadWeatherData() {
    if (state.isWeatherLoading) return Promise.resolve();
    state.isWeatherLoading = true;

    if (CONFIG.demoMode) {
      state.weatherById = createDemoWeather();
      state.lastWeatherSuccess = new Date();
      state.isWeatherLoading = false;
      renderAll();
      updateFooter();
      return Promise.resolve();
    }

    return mapLimit(RIVERS, CONFIG.maxWeatherConcurrency, fetchNwsForecastForRiver)
      .then(function (weatherItems) {
        weatherItems.forEach(function (item, index) {
          state.weatherById[RIVERS[index].id] = item;
        });
        state.lastWeatherSuccess = new Date();
        renderAll();
      })
      .finally(function () {
        state.isWeatherLoading = false;
        updateFooter();
      });
  }

  function dayLabel(dateValue) {
    var date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return "DAY";
    return date.toLocaleDateString([], { weekday: "short" }).toUpperCase();
  }

  function weatherDayHtml(day) {
    var iconHtml;
    if (day.icon) {
      var safeIcon = escapeHtml(day.icon);
      var fallback = weatherSymbol(day.shortForecast);
      iconHtml = '<img class="bqa-tv-weather-icon" src="' + safeIcon + '" alt="' + escapeHtml(day.shortForecast) + '" referrerpolicy="no-referrer" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'grid\';">' +
        '<span class="bqa-tv-weather-symbol" style="display:none">' + fallback + "</span>";
    } else {
      iconHtml = '<span class="bqa-tv-weather-symbol">' + weatherSymbol(day.shortForecast) + "</span>";
    }

    var high = day.high == null ? "--" : Math.round(day.high) + "&deg;";
    var low = day.low == null ? "--" : Math.round(day.low) + "&deg;";
    return (
      '<div class="bqa-tv-weather-day" title="' + escapeHtml(day.shortForecast) + '">' +
        '<div class="bqa-tv-weather-label">' + dayLabel(day.date) + "</div>" +
        '<div class="bqa-tv-weather-icon-wrap">' + iconHtml + "</div>" +
        '<div class="bqa-tv-weather-temps"><div>' + high + '</div><div class="low">' + low + "</div></div>" +
      "</div>"
    );
  }

  function weatherHtml(weather) {
    if (!weather || !Array.isArray(weather.days) || !weather.days.length) {
      return '<div class="bqa-tv-weather"><div class="bqa-tv-weather-unavailable">FORECAST UNAVAILABLE</div></div>';
    }
    return '<div class="bqa-tv-weather">' + weather.days.slice(0, 3).map(weatherDayHtml).join("") + "</div>";
  }

  function loadingRowHtml(river) {
    return (
      '<div class="bqa-tv-row">' +
        '<div class="bqa-tv-river">' +
          '<div class="bqa-tv-river-name">' + escapeHtml(river.river) + "</div>" +
          '<div class="bqa-tv-location">' + escapeHtml(river.location) + "</div>" +
          '<div class="bqa-tv-source"><span class="bqa-tv-loading-line short"></span></div>' +
        "</div>" +
        '<div class="bqa-tv-metric"><span class="bqa-tv-loading-line"></span></div>' +
        '<div class="bqa-tv-metric"><span class="bqa-tv-loading-line"></span></div>' +
        '<div class="bqa-tv-metric"><span class="bqa-tv-loading-line"></span></div>' +
        '<div class="bqa-tv-weather"><span class="bqa-tv-loading-line"></span><span class="bqa-tv-loading-line"></span><span class="bqa-tv-loading-line"></span></div>' +
      "</div>"
    );
  }

  function rowHtml(river) {
    var flow = state.flowById[river.id];
    var weather = state.weatherById[river.id];
    if (!flow) return loadingRowHtml(river);

    var readingAge = flow.currentTime ? Date.now() - new Date(flow.currentTime).getTime() : null;
    var stale = readingAge != null && readingAge > CONFIG.staleReadingMs;
    var rowClasses = ["bqa-tv-row"];
    if (stale) rowClasses.push("is-stale");
    if (flow.cached) rowClasses.push("is-cached");

    var sourceLine = flow.source;
    if (flow.currentTime) sourceLine += " / " + minutesAgoText(flow.currentTime);
    if (flow.cached) sourceLine += " / CACHED";
    else if (stale) sourceLine += " / STALE";

    var historyNote = flow.historicalLabel || "NO HISTORY";
    var temperatureClass = tempClass(flow.tempF);
    var tempSourceNote = tempNote(flow.tempF);
    if (flow.tempF != null && flow.tempSource) tempSourceNote += " / " + flow.tempSource;
    if (flow.tempF != null && flow.tempTime) {
      var tempAge = Date.now() - new Date(flow.tempTime).getTime();
      if (tempAge > CONFIG.staleReadingMs) tempSourceNote += " / STALE";
    }

    return (
      '<div class="' + rowClasses.join(" ") + '">' +
        '<div class="bqa-tv-river">' +
          '<div class="bqa-tv-river-name">' + escapeHtml(river.river) + "</div>" +
          '<div class="bqa-tv-location">' + escapeHtml(river.location) + "</div>" +
          '<div class="bqa-tv-source">' + escapeHtml(sourceLine) + "</div>" +
        "</div>" +
        '<div class="bqa-tv-metric bqa-tv-current">' +
          '<div class="bqa-tv-number' + (flow.current == null ? " bqa-tv-no-data" : "") + '">' + formatFlow(flow.current) + "</div>" +
          '<div class="bqa-tv-unit">CFS</div>' +
        "</div>" +
        '<div class="bqa-tv-metric bqa-tv-history">' +
          '<div class="bqa-tv-number' + (flow.historical == null ? " bqa-tv-no-data" : "") + '">' + formatFlow(flow.historical) + "</div>" +
          '<div class="bqa-tv-metric-note">' + escapeHtml(historyNote) + "</div>" +
        "</div>" +
        '<div class="bqa-tv-metric bqa-tv-temp ' + temperatureClass + '">' +
          '<div class="bqa-tv-number' + (flow.tempF == null ? " bqa-tv-no-data" : "") + '">' + formatTemp(flow.tempF) + "</div>" +
          '<div class="bqa-tv-metric-note">' + escapeHtml(tempSourceNote) + "</div>" +
        "</div>" +
        weatherHtml(weather) +
      "</div>"
    );
  }

  function renderAll() {
    var midpoint = Math.ceil(RIVERS.length / 2);
    leftEl.innerHTML = RIVERS.slice(0, midpoint).map(rowHtml).join("");
    rightEl.innerHTML = RIVERS.slice(midpoint).map(rowHtml).join("");
    updateFooter();
  }

  function setStatus(text, type) {
    statusEl.textContent = text;
    liveDotEl.classList.remove("is-loading", "has-errors");
    if (type === "loading") liveDotEl.classList.add("is-loading");
    if (type === "warning") liveDotEl.classList.add("has-errors");
  }

  function updateFooter() {
    var parts = [];
    if (state.lastFlowSuccess) {
      parts.push("RIVERS " + state.lastFlowSuccess.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }));
    }
    if (state.lastWeatherSuccess) {
      parts.push("WEATHER " + state.lastWeatherSuccess.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }));
    }
    if (CONFIG.demoMode) parts.push("DEMO MODE");
    updatedEl.textContent = parts.length ? "UPDATED: " + parts.join(" / ") : "STARTING LIVE UPDATE...";
  }

  function initialRender() {
    state.flowById = {};
    state.weatherById = {};
    renderAll();
  }

  function requestFullScreen() {
    var target = document.documentElement;
    if (!document.fullscreenElement && target.requestFullscreen) {
      target.requestFullscreen().catch(function () {});
    }
  }

  document.addEventListener("keydown", function (event) {
    var key = String(event.key || "").toLowerCase();
    if (key === "r") {
      loadFlowData();
      loadWeatherData();
    }
    if (key === "f") requestFullScreen();
  });
/* BQA TV PAGE - HIDE AVADA ACCESSIBILITY WIDGET */
(function () {
  function hideAvadaAccessibility() {
    var dashboard = document.getElementById("bqa-tv-streamflow");
    if (!dashboard) return;

    var selectors = [
      '[class*="avada"]',
      '[id*="avada"]',
      '[class*="sea-accessibility"]',
      '[id*="sea-accessibility"]',
      '[class*="accessibility-widget"]',
      '[id*="accessibility-widget"]',
      'iframe[src*="avada"]',
      'iframe[src*="accessibility"]'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (!dashboard.contains(el)) {
          el.style.setProperty("display", "none", "important");
          el.style.setProperty("visibility", "hidden", "important");
          el.style.setProperty("opacity", "0", "important");
          el.style.setProperty("pointer-events", "none", "important");
        }
      });
    });
  }

  hideAvadaAccessibility();

  var observer = new MutationObserver(function () {
    hideAvadaAccessibility();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  setTimeout(hideAvadaAccessibility, 500);
  setTimeout(hideAvadaAccessibility, 1500);
  setTimeout(hideAvadaAccessibility, 3000);
  setTimeout(hideAvadaAccessibility, 5000);
})();







  app.addEventListener("dblclick", requestFullScreen);

  formatClock();
  initialRender();
  loadFlowData();
  loadWeatherData();

  setInterval(formatClock, 30 * 1000);
  setInterval(loadFlowData, CONFIG.flowRefreshMs);
  setInterval(loadWeatherData, CONFIG.weatherRefreshMs);
  setTimeout(function () { window.location.reload(); }, CONFIG.hardReloadMs);
})();



